<template>
  <div class="tree-layout">

    <div style="line-height: 44px">
      <div @click="reflashClick" class="cp" style="font-size: 13px"><span class="el-icon-refresh" :class="[rotating?'rotating':'']"> </span> 刷新</div>
      <div v-if="copy" @click.self="clickEvent" class="copy-channel">复制栏目</div>
    </div>
    <el-tree :props="props" :load="ansyTree" lazy :indent='16' node-key="id"
             :default-expanded-keys="['']"
             @node-click="getNodes"
             v-if="refash"
    ></el-tree>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    props: {
      copy: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        props: {
          label: "name",
          children: "zones",
          isLeaf: "isChild",
          id: "id"
        },
        root: '',
        refash: true,
        rotating: true
      };
    },
    methods: {
      clickEvent() {
        this.routerLink('/channel/copy', 'copy', 0);
      },
      reflashClick() {
        this.refash = false;
        setTimeout(() => {
          this.refash = true;
        }, 100);
      },
      getNodes(data, node) {

        this.$emit('change', data, node);
      },
      ansyTree(node, resolve) {
        console.log("1@@!!!");
        console.log(node, "1@@!!!");
        let api = this.$api;
        //异步加载树形结构
        if (node.level === 0) {

          return resolve([
            {
              name: "根目录",
              id: ''
            }
          ]);
        }
        if (node.level > 0) {
          this.rotating = true;
          let id = node.data.id
          if (id !== '') {
            id = node.data.data.channelId
          }
          this.$fetchData(api.contentTree, {parentId: id}, 'post', "application/x-www-form-urlencoded").then(res => {
            this.rotating = false;
            const data = [];
            for (let i in res.content) {
              let obj = {};
              obj.id = res.content[i].channelId;
              obj.isChild = res.content[i].childCount > 0 ? false : true;
              // obj.isChild = false;
              obj.name = res.content[i].name;
              obj.data = res.content[i];
              data.push(obj);
            }
            return resolve(data);
          }).catch(error => {
            this.rotating = false;
          });
        }
      }
    }
  };
</script>

<style lang='scss' scoped>
  @keyframes rotating {
    from {
      transform: rotate(0)
    }
    to {
      transform: rotate(360deg)
    }
  }

  .rotating {
    animation: rotating 1.2s linear infinite
  }

  .copy-channel {
    color: #4184b7;
  }
</style>
